import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';

@Component({
  selector: 'nb-change-password-request',
  templateUrl: './change-password-request.component.html',
  styleUrls: ['./change-password-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbChangePasswordRequestComponent implements OnInit {
  submitted = false;
  email = '';

  constructor(
    private _apiService: ApiService,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const user = this._apiService.getValueLocalstorage();
    this.email = user?.email || '';
    this.cd.detectChanges();
  }

  requestChangePassword(): void {
    if (!this.email) {
      this._apiService.warning('Unable to find logged in email.');
      return;
    }

    this.submitted = true;
    const url = `${URLConfig.sendVerificationEmailAdmin}?email=${encodeURIComponent(this.email)}`;
    this._apiService.postRequest(url, {}).subscribe(
      () => {
        this._apiService.success('Verification email sent.');
        this.router.navigate(['/auth/change-password/confirm'], { queryParams: { email: this.email } });
        this.submitted = false;
        this.cd.detectChanges();
      },
      () => {
        this._apiService.error('Unable to send verification email.');
        this.submitted = false;
        this.cd.detectChanges();
      },
    );
  }
}
